<div class="container m-1">
  <div class=" m-1">
    @if (isLoadingLabelVisible) {
      <div class="modal">
        <div class="modal-dialog-content">
          <p>{{loadingMessage}}</p>
        </div>
      </div>
    }
    <div class="btn-group my-1">
      <button (click)="addItem()" class="btn btn-sm my-btn">
        <span class="mdi--add"></span>
      </button>
      <button (click)="generateChecklist()" class="btn btn-sm my-btn">
        <span class="mdi--alien-outline"></span>
        Generate checklist
      </button>
    </div>
    <div cdkDropList [cdkDropListData]="items" (cdkDropListDropped)="changeOrder($event)" class="list my-1 w-100">
      @for (item of items; track item; let i = $index) {
        <div class="box item d-flex align-items-center my-1"  cdkDrag>
          <div class="btn-group w-100">
            @if (item.checked) {
              <div class="mdi--checkbox-outline cursor-pointer " (click)="checkItem(i)"></div>
            } @else {
              <div class="mdi--checkbox-blank-outline cursor-pointer" (click)="checkItem(i)"></div>
            }
            <input #itemInput type="text" [(ngModel)]="item.name" (change)="updateItem(i, item.name)" (keydown)="handleKeydown($event, i)" class="form-control input-no-frame mx-1 px-1" [ngClass]="{'item-checked': item.checked}">
            <button (click)="removeItem(i)" class="btn btn-sm my-btn">
              <span class="mdi--close"></span>
            </button>
          </div>
        </div>
      }
    </div>
  </div>
</div>